import { useState } from 'react'
import { supabase } from '../supabaseClient'
import { useNavigate } from 'react-router-dom'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://completept.app/reset-password'
    })

    if (error) { setError(error.message); setLoading(false); return }
    setSent(true)
    setLoading(false)
  }

  return (
    <div style={{ minHeight: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #3730a3 100%)', padding: '1.5rem', paddingTop: 'max(1.5rem, env(safe-area-inset-top))' }}>
      <div style={{ width: '100%', maxWidth: 420, background: 'white', borderRadius: 20, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '2rem 2rem 1.5rem', background: 'linear-gradient(135deg, #6366f1, #4f46e5)' }}>
          <p style={{ fontWeight: 800, fontSize: 20, color: 'white', letterSpacing: -0.5, margin: '0 0 1rem' }}>Complete PT</p>
          <p style={{ fontSize: 24, fontWeight: 700, color: 'white', lineHeight: 1.2, letterSpacing: -0.5, margin: '0 0 0.5rem' }}>Reset password</p>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, margin: 0 }}>We'll send you a reset link</p>
        </div>

        <div style={{ padding: '2rem' }}>
          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: '1rem' }}>📧</div>
              <p style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: 16, marginBottom: 8 }}>Check your email</p>
              <p style={{ fontSize: 14, marginBottom: '1.5rem' }}>We sent a reset link to <strong>{email}</strong></p>
              <button className="secondary" onClick={() => navigate('/login')} style={{ width: '100%', padding: 14 }}>
                Back to sign in
              </button>
            </div>
          ) : (
            <>
              {error && <div className="alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <div className="form-field">
                  <label className="form-label">Email address</label>
                  <input type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required />
                </div>
                <button type="submit" disabled={loading} style={{ marginTop: 4, padding: 14, fontSize: 15 }}>
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </form>
              <p style={{ textAlign: 'center', marginTop: '1.5rem', margin: '1.5rem 0 0' }}>
                <span onClick={() => navigate('/login')} style={{ color: 'var(--brand)', fontWeight: 600, cursor: 'pointer' }}>
                  Back to sign in
                </span>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
